(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var menu = document.querySelector('[data-menu]');
    document.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (menu) { menu.hidden = false; b.setAttribute('aria-expanded', 'true'); } });
    });
    document.querySelectorAll('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { if (menu) menu.hidden = true; });
    });

    // Country/currency dropdown
    document.querySelectorAll('[data-loc-toggle]').forEach(function (t) {
      var list = t.parentElement.querySelector('[data-loc-list]');
      t.addEventListener('click', function () {
        var open = !list.hidden;
        list.hidden = open;
        t.setAttribute('aria-expanded', String(!open));
      });
      document.addEventListener('click', function (e) {
        if (!t.parentElement.contains(e.target)) { list.hidden = true; t.setAttribute('aria-expanded', 'false'); }
      });
    });
  })();

  // Shared scroll-reveal
  (function () {
    var els = document.querySelectorAll('.fade-up');
    if (!els.length || !('IntersectionObserver' in window)) { els.forEach(function (el){ el.classList.add('is-visible'); }); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mie-annc[data-hours]').forEach(function (bar) {
    var timer = bar.querySelector('.mie-annc__timer');
    if (!timer) return;
    var hEl = timer.querySelector('[data-h]');
    var mEl = timer.querySelector('[data-m]');
    var sEl = timer.querySelector('[data-s]');
    var hours = parseFloat(bar.getAttribute('data-hours')) || 3;
    var key = 'mieAnnc:' + bar.id;
    var end = parseInt(sessionStorage.getItem(key), 10);
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      sessionStorage.setItem(key, end);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      hEl.textContent = pad(Math.floor(s / 3600));
      mEl.textContent = pad(Math.floor((s % 3600) / 60));
      sEl.textContent = pad(s % 60);
      if (diff <= 0) { end = Date.now() + hours * 3600 * 1000; sessionStorage.setItem(key, end); }
    }
    tick();
    setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mie-reviews').forEach(function (root) {
    var track = root.querySelector('[data-review-track]');
    if (!track) return;
    var card = track.querySelector('.mie-review');
    var step = card ? card.offsetWidth + 20 : 360;
    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step, behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var cfg = {};
    var cfgEl = pdp.querySelector('[data-pdp-config]');
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    var i18n = cfg.i18n || {};
    var moneyFormat = cfg.moneyFormat || ('$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125));

    // Currency-aware money for COMPUTED sums (variant/bundle totals, savings).
    // Headline prices use the server-side `money`-filtered strings in [data-variant-money],
    // which Shopify already localizes to the active presentment currency.
    // Real multi-currency requires Shopify Markets + additional currencies (Shopify Payments).
    function money(cents) {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        var rate = parseFloat(Shopify.currency.rate || '1') || 1;
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: Shopify.currency.active }).format((cents / 100) * rate); } catch (e) {}
      }
      var v = (cents / 100).toFixed(2);
      if (moneyFormat.indexOf('amount_no_decimals') !== -1) v = Math.round(cents / 100).toString();
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, v);
    }

    // Gallery
    var slides = pdp.querySelectorAll('[data-slide]');
    var thumbs = pdp.querySelectorAll('[data-thumb]');
    var idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    var gp = pdp.querySelector('[data-g-prev]'); if (gp) gp.addEventListener('click', function () { show(idx - 1); });
    var gn = pdp.querySelector('[data-g-next]'); if (gn) gn.addEventListener('click', function () { show(idx + 1); });

    // Data
    var variants = [];
    try { variants = JSON.parse((pdp.querySelector('[data-variants]') || document.querySelector('[data-variants]')).textContent); } catch (e) {}
    var vmoney = {};
    try { vmoney = JSON.parse(pdp.querySelector('[data-variant-money]').textContent); } catch (e) {}
    var currentPid = cfg.productId;

    var form = pdp.querySelector('.mie-pform');
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var saveEl = pdp.querySelector('[data-save]');
    var qtyInput = pdp.querySelector('[data-quantity]');
    var subTotal = pdp.querySelector('[data-sub-total]');
    var subCompare = pdp.querySelector('[data-sub-compare]');
    var subSaving = pdp.querySelector('[data-sub-saving]');
    var addBtn = pdp.querySelector('[data-add]');
    var addLabel = pdp.querySelector('[data-add-label]');

    var tiers = Array.prototype.slice.call(pdp.querySelectorAll('[data-tier]'));
    var hasTiers = tiers.length > 0;

    function current() {
      if (!form) return variants[0];
      var selected = [];
      form.querySelectorAll('[data-option-input]').forEach(function (inp) { if (inp.checked) selected.push(inp.value); });
      if (!selected.length) return variants[0];
      return variants.filter(function (v) { return v.options.join('~~') === selected.join('~~'); })[0] || variants[0];
    }
    function qty() { return parseInt(qtyInput.value, 10) || 1; }

    // ---------- Bundle dropdowns (options are server-rendered in the DOM) ----------
    function closeAllDD() {
      pdp.querySelectorAll('[data-dd-list]').forEach(function (l) { l.hidden = true; });
      pdp.querySelectorAll('[data-dd-btn]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    pdp.querySelectorAll('[data-dd]').forEach(function (dd) {
      var list = dd.querySelector('[data-dd-list]');
      var btn = dd.querySelector('[data-dd-btn]');
      var label = dd.querySelector('[data-dd-label]');
      if (!list || !btn) return;
      dd._selected = list.querySelector('[role="option"][aria-selected="true"]') || list.querySelector('[role="option"]');
      if (label && dd._selected) { label.textContent = dd._selected.getAttribute('data-title') || label.textContent; }
      btn.addEventListener('click', function () {
        var willOpen = list.hidden;
        closeAllDD();
        list.hidden = !willOpen;
        btn.setAttribute('aria-expanded', String(willOpen));
      });
      list.querySelectorAll('[role="option"]').forEach(function (op) {
        op.addEventListener('click', function () {
          dd._selected = op;
          if (label) label.textContent = op.getAttribute('data-title') || '';
          list.querySelectorAll('[role="option"]').forEach(function (o) { o.setAttribute('aria-selected', o === op ? 'true' : 'false'); });
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          recompute();
        });
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-dd]')) closeAllDD(); });

    function activeTier() {
      var checked = pdp.querySelector('[data-tier-radio]:checked');
      return checked ? checked.closest('[data-tier]') : (tiers[0] || null);
    }
    function slotVariantId(slot) {
      var dd = slot.querySelector('[data-dd]');
      var li = dd && dd._selected;
      if (!li) return null;
      var vid = parseInt(li.getAttribute('data-variant-id'), 10);
      var pid = parseInt(li.getAttribute('data-pid'), 10);
      // Respect the on-page size selector when the current product is chosen.
      if (pid === currentPid && idInput) { return parseInt(idInput.value, 10) || vid; }
      return vid || null;
    }
    function tierItems(tier) {
      if (!tier) return [{ id: parseInt(idInput.value, 10), quantity: qty() }];
      var type = tier.getAttribute('data-type');
      if (type === 'fixed') {
        var fx = tier.querySelector('[data-fixed-items]');
        var ids = [];
        try { ids = JSON.parse(fx.getAttribute('data-fixed-items')); } catch (e) {}
        return ids.filter(function (id) { return id; }).map(function (id) { return { id: id, quantity: 1 }; });
      }
      var items = [];
      tier.querySelectorAll('[data-slot]').forEach(function (slot) {
        var vid = slotVariantId(slot);
        if (vid) items.push({ id: vid, quantity: 1 });
      });
      if (!items.length && idInput) items = [{ id: parseInt(idInput.value, 10), quantity: qty() }];
      return items;
    }

    function recompute() {
      var tier = activeTier();
      var subtotal = 0, compare = 0;
      if (tier) {
        var type = tier.getAttribute('data-type');
        if (type === 'fixed') {
          var fx = tier.querySelector('[data-fixed-items]');
          var prices = [], compares = [];
          if (fx) {
            try { prices = JSON.parse(fx.getAttribute('data-fixed-prices') || '[]'); } catch (e) {}
            try { compares = JSON.parse(fx.getAttribute('data-fixed-compares') || '[]'); } catch (e) {}
          }
          prices.forEach(function (p, i) { subtotal += p; compare += (compares[i] > p ? compares[i] : p); });
        } else {
          tier.querySelectorAll('[data-slot]').forEach(function (slot) {
            var dd = slot.querySelector('[data-dd]');
            var li = dd && dd._selected;
            if (!li) return;
            var price = parseInt(li.getAttribute('data-price'), 10) || 0;
            var comp = parseInt(li.getAttribute('data-compare'), 10) || 0;
            var isFree = slot.getAttribute('data-free') === 'true';
            subtotal += isFree ? 0 : price;
            compare += (comp > price ? comp : price);
          });
        }
      }
      if (subTotal) subTotal.textContent = money(subtotal);
      if (subCompare) subCompare.textContent = (compare > subtotal) ? money(compare) : '';
      if (subSaving) {
        var save = compare - subtotal;
        if (save > 0) { subSaving.textContent = (i18n.saving || '') + ' ' + money(save); subSaving.hidden = false; }
        else { subSaving.hidden = true; }
      }
    }

    function render() {
      var v = current();
      if (!v) return;
      idInput.value = v.id;
      var vm = vmoney[v.id];
      if (vm) {
        priceEl.textContent = vm.price;
        if (compareEl) { if (vm.hasCompare) { compareEl.textContent = vm.compare; compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      } else {
        priceEl.textContent = money(v.price);
        if (compareEl) { if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      }
      if (saveEl) { if (v.compare_at_price > v.price) { saveEl.textContent = (i18n.save || 'Save') + ' ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; saveEl.style.display = ''; } else { saveEl.style.display = 'none'; } }
      if (addBtn) {
        addBtn.disabled = !v.available;
        // Never blank the label — fall back to the server-rendered text if i18n is empty.
        var lbl = v.available ? i18n.add : i18n.soldOut;
        if (lbl) { addLabel.textContent = lbl; }
      }
      form.querySelectorAll('.mie-pform__swatch').forEach(function (sw) { var inp = sw.querySelector('input'); sw.classList.toggle('is-active', inp.checked); });

      if (hasTiers) { recompute(); }
      else if (subTotal) {
        var q = qty();
        subTotal.textContent = money(v.price * q);
        if (subCompare) subCompare.textContent = (v.compare_at_price > v.price) ? money(v.compare_at_price * q) : '';
        if (subSaving) { var s = (v.compare_at_price > v.price) ? (v.compare_at_price - v.price) * q : 0; if (s > 0) { subSaving.textContent = (i18n.saving || '') + ' ' + money(s); subSaving.hidden = false; } else { subSaving.hidden = true; } }
      }
    }

    function syncTiers() {
      tiers.forEach(function (t) {
        var radio = t.querySelector('[data-tier-radio]');
        var on = radio && radio.checked;
        t.classList.toggle('is-active', on);
        var exp = t.querySelector('[data-expand]');
        if (exp) exp.hidden = !on;
      });
      recompute();
    }

    if (form) {
      form.querySelectorAll('[data-option-input]').forEach(function (inp) { inp.addEventListener('change', render); });
      form.querySelectorAll('[data-tier-radio]').forEach(function (r) { r.addEventListener('change', syncTiers); });
      var subToggle = form.querySelector('[data-sub-toggle]');
      var planInput = form.querySelector('[data-selling-plan]');
      if (subToggle && planInput) {
        subToggle.addEventListener('change', function () { planInput.value = subToggle.checked ? planInput.getAttribute('data-plan-id') : ''; });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items;
        try { items = hasTiers ? tierItems(activeTier()) : [{ id: parseInt(idInput.value, 10), quantity: qty() }]; }
        catch (err) { items = [{ id: parseInt(idInput.value, 10), quantity: qty() }]; }
        items = (items || []).filter(function (it) { return it && it.id; });
        if (!items.length) return;
        var sp = form.querySelector('[data-selling-plan]');
        if (sp && sp.value) { items = items.map(function (it) { it.selling_plan = sp.value; return it; }); }
        var addBtnEl = form.querySelector('[data-add]');
        if (addBtnEl) { addBtnEl.setAttribute('aria-busy', 'true'); }
        function done() { if (addBtnEl) { addBtnEl.removeAttribute('aria-busy'); } }
        var addUrl = (cfg.addUrl || '/cart/add');
        if (window.mieCartAddItems) {
          // Route through the drawer's proven add path (same one the collection
          // "Add to basket" uses) — adds the items and opens the sidebar.
          Promise.resolve(window.mieCartAddItems(items)).then(done, done);
        } else {
          fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { return r.json(); })
            .then(function () {
              document.dispatchEvent(new CustomEvent('mie:cart:open'));
              if (window.mieCartOpen) { try { window.mieCartOpen(); } catch (err) {} }
            })
            .catch(function () {})
            .then(done);
        }
      });
    }

    if (hasTiers) syncTiers();
    render();

    // Sticky bar reveal after hero add-to-cart scrolls out
    var bar = document.querySelector('[data-stickybar]');
    var addWrap = pdp.querySelector('.mie-pform__add');
    if (bar && addWrap && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.hidden = en.isIntersecting; });
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(addWrap);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
